import script from "./AppMenuAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenuAdmin.vue?vue&type=script&setup=true&lang=js"

import "./AppMenuAdmin.vue?vue&type=style&index=0&id=1217ca63&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1217ca63"]])

export default __exports__